module.exports = __webpack_public_path__ + "static/two-bd413caeee88ff839068751c6bb3296a.png";